<template>
  <div>
    <!-- -------------------------Proximas Evaluaciones Profesor------------------------- -->
    <Card
      v-if="user && user.group_names.includes('PROFESORES')"
      class="dashboard-card"
      :hide_title="hide_title"
    >
      <template v-slot:title>
        <b-icon class="card-header-icon" icon="calendar3"></b-icon>
        {{
          $t("dashboard.dashboardView.next", {
            entity: $getVisibleNames(
              "evaluations2.evaluation",
              true,
              "Evaluaciones"
            ),
          })
        }}
      </template>
      <template v-slot:content>
        <template v-if="institution && institution.kl_assessment">
          <div
            v-if="
              next_evaluation_teacher.length != 0 ||
              optionsMatterNextTest.length > 1 ||
              optionsCareerNextTest.length > 1 ||
              optionsSectionNextTest.length > 1 ||
              optionsCampuNextTest.length > 1
            "
            class="container-select mb-2 noprint"
          >
            <div>
              <b-form-select
                id="input-campus"
                class="select-form"
                v-model="select_campus_next_test"
                :options="optionsCampuNextTest"
                @change="getNextEvaluationStudent()"
              ></b-form-select>
            </div>
            <div>
              <b-form-select
                id="input-career"
                class="select-form"
                v-model="select_career_next_test"
                :options="optionsCareerNextTest"
                @change="getNextEvaluationStudent()"
              ></b-form-select>
            </div>
            <div>
              <b-form-select
                id="input-matter"
                class="select-form"
                v-model="select_matter_next_test"
                :options="optionsMatterNextTest"
                @change="getNextEvaluationStudent()"
              ></b-form-select>
            </div>
            <div>
              <b-form-select
                id="input-section"
                class="select-form"
                v-model="select_section_next_test"
                :options="optionsSectionNextTest"
                @change="getNextEvaluationStudent()"
              ></b-form-select>
            </div>
          </div>
          <template
            v-if="
              user.group_names.includes('PROFESORES') &&
              next_evaluation_teacher.length > 0
            "
          >
            <b-table-simple
              borderless
              small
              hover
              sticky-header="400px"
              class="border-table"
            >
              <b-thead>
                <b-tr>
                  <!-- Columna Nombre Evaluacion (Evaluacion)-->
                  <b-th class="primary-cell-next-test" style="width: 11%">
                    {{
                      $getVisibleNames(
                        "evaluations2.evaluation",
                        false,
                        "Evaluación"
                      )
                    }}
                  </b-th>
                  <!-- Columna Nombre Evaluacion (Test) -->
                  <b-th class="primary-cell-next-test" style="width: 11%">
                    <!-- {{
                        $getVisibleNames(
                          "teaching.evaluationsituation",
                          false,
                          "Situación Evaluativa"
                        )
                      }} -->
                    {{
                      $getVisibleNames(
                        "evaluations2.test",
                        false,
                        "Instrumento"
                      )
                    }}
                  </b-th>
                  <b-th class="primary-cell-next-test" style="width: 9%">
                    {{ $getVisibleNames("mesh.campus", false, "Sede") }}
                  </b-th>
                  <b-th class="primary-cell-next-test" style="width: 11%">
                    {{ $getVisibleNames("mesh.career", false, "Programa") }}
                  </b-th>
                  <b-th class="primary-cell-next-test" style="width: 11%">{{
                    $getVisibleNames(
                      "mesh.egressprofilematter",
                      false,
                      "Asignatura"
                    )
                  }}</b-th>
                  <b-th class="primary-cell-next-test" style="width: 7%">
                    {{ $getVisibleNames("teaching.section", false, "Sección") }}
                  </b-th>
                  <b-th class="primary-cell-next-test" style="width: 5%">{{
                    $t("reusable.common.startDate")
                  }}</b-th>
                  <b-th class="primary-cell-next-test" style="width: 5%">{{
                    $t("reusable.common.endDate")
                  }}</b-th>
                  <b-th class="primary-cell-next-test" style="width: 5%">{{
                    $t("dashboard.dashboardView.visibleForEvaluatees")
                  }}</b-th>
                </b-tr>
              </b-thead>

              <b-tbody>
                <!-- {{next_evaluation_teacher}} -->
                <template v-for="test in sortedEvaluations">
                  <b-tr :key="test.id">
                    <!-- Nombre de la Evaluacion (Evaluacion) -->
                    <b-td class="secondary-cell-next-test text-left">
                      <div class="mr-0">
                        {{ test.evaluation_title }}
                      </div>
                    </b-td>
                    <!-- Nombre de la Evaluacion (Test) -->
                    <b-td class="secondary-cell-next-test text-left">
                      <span
                        class="div-href-test"
                        @click="
                          redirectToTestTeacher(test.evaluation_id, test.id)
                        "
                        v-b-tooltip.v-secondary.top.noninteractive="{
                          title: $t('dashboard.dashboardView.goToThe', {
                            entity: $getVisibleNames(
                              'evaluations2.evaluation',
                              false,
                              'Evaluación'
                            ),
                          }),
                          boundary: 'viewport',
                        }"
                      >
                        {{ test.title }}
                      </span>
                    </b-td>
                    <!-- Sede -->
                    <b-td class="secondary-cell-next-test text-left">
                      {{ test.campus }}
                    </b-td>
                    <!-- Carrera -->
                    <b-td class="secondary-cell-next-test text-left">
                      {{ test.career_name }}
                    </b-td>
                    <!-- Asignatura -->
                    <b-td class="secondary-cell-next-test text-left">
                      {{ test.matter_code }} - {{ test.matter_name }}
                    </b-td>
                    <!-- Seccion -->
                    <b-td class="secondary-cell-next-test text-left">
                      {{ test.section_name }}
                    </b-td>
                    <!-- Fecha de Inicio -->
                    <b-td
                      class="secondary-cell-next-test text-left"
                      :class="{
                        'text-blue': isDateInProgress(
                          test.start_time,
                          test.end_time
                        ),
                      }"
                      v-b-tooltip.v-secondary.top.noninteractive="{
                        title: isDateInProgress(test.start_time, test.end_time)
                          ? $t('dashboard.dashboardView.inProgress', {
                              entity: $getVisibleNames(
                                'evaluations2.evaluation',
                                false,
                                'Evaluación'
                              ),
                            })
                          : '',
                        boundary: 'viewport',
                      }"
                    >
                      <template v-if="test.start_time">
                        {{ test.start_time | FormatToDateTime }}
                      </template>
                      <template v-else> N/A </template>
                    </b-td>
                    <!-- Fecha de Termino -->
                    <b-td
                      class="secondary-cell-next-test text-left"
                      :class="{
                        'text-blue': isDateInProgress(
                          test.start_time,
                          test.end_time
                        ),
                      }"
                      v-b-tooltip.v-secondary.top.noninteractive="{
                        title: isDateInProgress(test.start_time, test.end_time)
                          ? $t('dashboard.dashboardView.inProgress', {
                              entity: $getVisibleNames(
                                'evaluations2.evaluation',
                                false,
                                'Evaluación'
                              ),
                            })
                          : '',
                        boundary: 'viewport',
                      }"
                    >
                      <template v-if="test.end_time">
                        {{ test.end_time | FormatToDateTime }}
                      </template>
                      <template v-else> N/A </template>
                    </b-td>
                    <b-td class="secondary-cell-next-test text-center">
                      <template v-if="test.visible_by_evaluatees">
                        <span>{{ $t("reusable.common.yes") }}</span>
                      </template>
                      <template v-else>
                        <span>{{ $t("reusable.common.no") }}</span>
                      </template>
                    </b-td>
                  </b-tr>
                </template>
              </b-tbody>
            </b-table-simple>
          </template>
          <!-- Si no hay evaluaciones -->
          <template
            v-if="
              user.group_names.includes('PROFESORES') &&
              next_evaluation_teacher.length == 0
            "
          >
            <div class="text-left">
              {{
                $t("dashboard.dashboardView.noNext", {
                  entity: $getVisibleNames(
                    "evaluations2.evaluation",
                    true,
                    "Evaluaciones"
                  ),
                })
              }}
            </div>
          </template>
        </template>
        <template v-else>
          <div class="text-left">
            <span>{{ $t("dashboard.dashboardView.moduleNotEnabled") }}</span>
          </div>
        </template>
      </template>
    </Card>
  </div>
</template>

<script>
// import * as names from "@/store/names";
import { mapGetters } from "vuex";
export default {
  name: "NextTestTeacher",
  components: {
    Card: () => import("@/components/users/Card"),
  },
  props: {
    hide_title: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      first_fetch_next_test: true,
      select_matter_next_test: null,
      select_career_next_test: null,
      select_section_next_test: null,
      select_campus_next_test: null,
      next_evaluation_teacher: [],
      optionsMatterNextTest: [],
      optionsCareerNextTest: [],
      optionsSectionNextTest: [],
      optionsCampuNextTest: [],
    };
  },
  computed: {
    ...mapGetters({
      user: "getUser",
      institution: "getInstitution",
    }),
    sortedEvaluations() {
      return this.next_evaluation_teacher.slice().sort((a, b) => {
        return new Date(a.start_time) - new Date(b.start_time);
      });
    },
  },
  methods: {
    isDateInProgress(start_time, end_time) {
      const now = new this.$moment();
      const startDate = this.$moment(start_time);
      const endDate = this.$moment(end_time);

      return startDate.isSameOrBefore(now) && endDate.isSameOrAfter(now);
      // estamos verificando si la fecha actual (now) está dentro del rango de tiempo
    },
    optionsMattersNextTest(mattersFromApi) {
      this.optionsMatterNextTest = [
        {
          value: null,
          text: this.$t("dashboard.dashboardView.filterBy", {
            entity: this.$getVisibleNames(
              "mesh.egressprofilematter",
              false,
              "Asignatura"
            ),
          }),
        },
      ];
      // Crear un Map para almacenar carreras únicas
      const uniqueMatters = new Map();
      // Iterar sobre los datos de la API y llenar el Map
      mattersFromApi.forEach((x) => {
        if (!uniqueMatters.has(x.matter_name)) {
          uniqueMatters.set(x.matter_name, x.matter_id);
        }
      });
      // Convertir el Map en un array de opciones y añadirlo a optionsMatterNextTest
      uniqueMatters.forEach((id, name) => {
        this.optionsMatterNextTest.push({
          value: id,
          text: name,
        });
      });
    },
    optionsCareersNextTest(careersFromApi) {
      this.optionsCareerNextTest = [
        {
          value: null,
          text: this.$t("dashboard.dashboardView.filterBy", {
            entity: this.$getVisibleNames("mesh.career", false, "Programa"),
          }),
        },
      ];
      const uniqueCareers = new Map();
      careersFromApi.forEach((x) => {
        if (!uniqueCareers.has(x.career_name)) {
          uniqueCareers.set(x.career_name, x.career_id);
        }
      });
      uniqueCareers.forEach((id, name) => {
        this.optionsCareerNextTest.push({
          value: id,
          text: name,
        });
      });
    },
    optionsSectionsNextTest(sectionsFromApi) {
      this.optionsSectionNextTest = [
        {
          value: null,
          text: this.$t("dashboard.dashboardView.filterBy", {
            entity: this.$getVisibleNames("teaching.section", false, "Sección"),
          }),
        },
      ];
      const uniqueSections = new Map();
      sectionsFromApi.forEach((x) => {
        if (!uniqueSections.has(x.section_name)) {
          uniqueSections.set(x.section_name, x.section_id);
        }
      });
      uniqueSections.forEach((id, name) => {
        this.optionsSectionNextTest.push({
          value: id,
          text: name,
        });
      });
    },
    optionsCampusNextTest(campusFromApi) {
      this.optionsCampuNextTest = [
        {
          value: null,
          text: this.$t("dashboard.dashboardView.filterBy", {
            entity: this.$getVisibleNames("mesh.campus", false, "Sede"),
          }),
        },
      ];
      const uniqueCampus = new Map();
      campusFromApi.forEach((x) => {
        if (!uniqueCampus.has(x.campus)) {
          uniqueCampus.set(x.campus, x.campus_id);
        }
      });
      uniqueCampus.forEach((id, name) => {
        this.optionsCampuNextTest.push({
          value: id,
          text: name,
        });
      });
    },
    redirectToTestTeacher(evaluation_id, instrument_id = null) {
      this.$router.push({
        name: "NewEvaluationView",
        params: {
          evaluation_id: evaluation_id,
          instrument_id: instrument_id,
        },
      });
    },
    getNextEvaluationStudent() {
      if (
        this.user &&
        this.user.group_names.includes("PROFESORES") &&
        this.institution &&
        this.institution.kl_assessment
      ) {
        let arr = [];

        if (this.select_campus_next_test != null)
          arr.push("campus=" + this.select_campus_next_test);
        if (this.select_career_next_test != null)
          arr.push("career=" + this.select_career_next_test);
        if (this.select_matter_next_test != null)
          arr.push("matter=" + this.select_matter_next_test);
        if (this.select_section_next_test != null)
          arr.push("section=" + this.select_section_next_test);

        let partial_url = "";
        if (arr.length > 0) partial_url = arr.join("&");

        this.$restful
          .Get(
            `/evaluations2/dashboard_teacher_next_tests/?has_dates=${true}&${partial_url}`
          )
          .then((response) => {
            this.next_evaluation_teacher = response;
            this.$emit("count", response.length);
            if (this.first_fetch_next_test) {
              this.optionsMattersNextTest(response);
              this.optionsCareersNextTest(response);
              this.optionsSectionsNextTest(response);
              this.optionsCampusNextTest(response);
              this.first_fetch_next_test = false;
            }
          });
      }
    },
  },
  mounted() {
    this.getNextEvaluationStudent();
  },
  watch: {
    user() {
      this.getNextEvaluationStudent();
    },
    institution() {
      this.getNextEvaluationStudent();
    },
  },
  created() {
    this.$hasPermissions();
  },
};
</script>

<style scoped>
.text-blue {
  color: var(--kl-color-primary);
  font-weight: var(--kl-fw-semibold);
}
.dashboard-card {
  display: block;
  margin: 0;
}
.dashboard-card >>> .card-container {
  background: var(--kl-surface);
  border: 1px solid var(--kl-border-soft);
  border-radius: var(--kl-card-radius);
  box-shadow: 0 2px 4px rgba(16, 38, 73, 0.06);
  overflow: hidden;
}
.dashboard-card >>> .card-body {
  background: var(--kl-surface) !important;
  padding: 16px;
}
.card-header-icon {
  margin-right: 0.35em;
}
.border-table {
  border-radius: var(--kl-radius-lg);
  border: 1px solid var(--kl-border);
  max-height: calc(100vh - 290px) !important;
  overflow-y: auto;
}
.border-table >>> table {
  margin-bottom: 0;
}
.border-table >>> tbody tr:nth-child(even) > td {
  background-color: var(--kl-surface-muted);
}
.border-table >>> tbody tr:hover > td {
  background-color: var(--kl-surface-hover);
}
.primary-cell-next-test {
  text-align: left;
  vertical-align: middle;
  background: var(--kl-color-accent-soft) !important;
  color: var(--kl-color-primary) !important;
  font-weight: var(--kl-fw-bold);
  font-size: var(--kl-fs-caption);
  text-transform: uppercase;
  letter-spacing: var(--kl-ls-wide);
  padding: 11px 12px !important;
  border-bottom: none !important;
  white-space: nowrap;
}
.secondary-cell-next-test {
  text-align: center;
  vertical-align: middle;
  color: var(--kl-text-body);
  font-size: var(--kl-fs-body);
  padding: 11px 12px !important;
  border-bottom: 1px solid var(--kl-border-soft) !important;
}
.div-href-test {
  color: var(--kl-color-primary);
  font-weight: var(--kl-fw-semibold);
  transition: color 0.2s ease;
}
.div-href-test:hover {
  color: var(--kl-color-primary-deep) !important;
  text-decoration: underline;
  cursor: pointer;
}
.container-select {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 14px;
}
.container-select > div {
  flex: 1 1 calc(25% - 10px);
  min-width: 200px;
}
.select-form {
  width: 100%;
  height: 40px;
  font-size: var(--kl-fs-body);
  color: var(--kl-text-heading);
  border: 1px solid var(--kl-border-soft) !important;
  border-radius: var(--kl-input-radius) !important;
  background-color: var(--kl-surface);
}
.select-form:focus {
  border-color: var(--kl-color-primary) !important;
  box-shadow: 0 0 0 3px rgba(0, 110, 200, 0.15) !important;
}
@media (max-width: 992px) {
  .container-select > div {
    flex: 1 1 calc(50% - 10px);
  }
}
@media (max-width: 576px) {
  .container-select > div {
    flex: 1 1 100%;
  }
}
@media print {
  .secondary-cell-next-test {
    background-color: transparent !important;
  }
}
</style>